<div class="container d-flex justify-content-center align-items-center" style="min-height: 60vh;">
	<div class="card shadow p-4" style="width: 100%; max-width: 460px; border-radius: 1rem;">
		<div class="text-center mb-4">
			<h4 class="fw-bold mb-5">Restablecer contraseña</h4>

		  	<form-steps 
				[pasos]="pasos" 
				[pasoActual]="pasoActual"
				[puedeAvanzar]="puedeAvanzar"
				(cambioPaso)="actualizarPaso($event)">
				<div class="container mt-3" *ngIf="pasoActual === 1">
					<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
					    <!-- Password -->
					    <div class="mb-3">
					      <label class="form-label">Correo electrónico</label>
					        <input 
					          type="email" 
					          class="form-control" 
					          formControlName="email" 
					          placeholder="Ingresa tu correo electrónico">
					      	
					      	<div *ngIf="formControl('password')?.touched && formControl('password')?.invalid">
					        	<small class="text-danger">Mínimo 8 caracteres, debe incluir letras y números</small>
					      	</div>
					    </div>
					</form>
				</div> <!-- /END pasoActual 1 -->

				<div class="container mt-3" *ngIf="pasoActual === 2">
					<ng-container *ngIf="codigoEstatusSolicitudCambioPassword === 500">
						<div class="alert alert-danger p-4 rounded-3 shadow-sm" role="alert">
						    <i class="bi bi-exclamation-triangle-fill fs-2 text-danger mb-3"></i>
						    <h5 class="fw-bold mb-2">No se pudo enviar el correo</h5>
						    <p class="mb-0">
						      Ocurrió un error al intentar enviar el correo de restablecimiento. <br /><br />
						      Por favor, inténtalo más tarde.
						    </p>
						</div>
					</ng-container>

					<ng-container *ngIf="codigoEstatusSolicitudCambioPassword === 200">
						<div class="alert alert-info p-4 rounded-3 shadow-sm" role="alert">
						    <i class="bi bi-envelope-paper-heart fs-2 text-primary mb-3"></i>
						    <h5 class="fw-bold mb-2">Correo enviado</h5>
						    <p class="mb-0">
						      Te hemos enviado un correo electrónico con un enlace para confirmar tu dirección. <br /><br />
						      Por favor, haz clic en el enlace para continuar con el proceso de restablecimiento de contraseña.
						    </p>
						</div>
					</ng-container>

				</div> <!-- /END pasoActual 2 -->
			</form-steps>
		</div>
	</div>
</div>